import { CancelToken } from 'axios'
import { TPageInfo, TQueryParams } from '../../components/Table/types'
import { IPartialUserInfo } from '../../redux/store/user/types'
import { SortOrder } from 'antd/lib/table/interface'

export type TContractCategoriesList = {
  uuid: string
  name: string
  led_by: TLedByCC[]
  // all users specific field
  community_level_owner?: IPartialUserInfo
  // CP specific fields
  sourcing_owner?: IPartialUserInfo
  sourcing_team?: IPartialUserInfo[]
}

export type TContractsCategoriesTableRequestData = {
  sortField?: keyof TContractCategoriesList
  sortOrder?: SortOrder
  filters?: TContractsCategoriesListFilters
  page?: TPageInfo
}

export type TLedByCC = {
  uuid: string
  led_by: string
  compliance_requirement: string
  not_measuring_compliance: boolean
  expected_spend: string
  expected_savings: string
  created_at: string | null
  earliest_contract_start_date: string | null
  latest_contract_finish_date: string | null
  latest_contract_inactive_date: string | null
  status_change_date: string | null
  status: ContractCategoryStatus | null
  responsible: IPartialUserInfo
  organization: {
    uuid: string
    name: string
  } | null
  led_by_name?: string
  contract_category_organization_name?: string
}

export type TContractsCategoriesListRequest = {
  params?: TContractsCategoriesListParams
  cancelToken?: CancelToken
}

export type TContractsCategoriesListFilters = {
  led_by?: string[]
  status?: string[]
}

export type TContractsCategoriesListParams = TContractsCategoriesListFilters &
  TQueryParams

export type TCCListFiltersFunc = (
  field: keyof TContractsCategoriesListFilters,
  filters: string[]
) => void

export type TCCListColumnsFunc = {
  applyFilters: TCCListFiltersFunc
  filters: TContractsCategoriesListFilters | undefined
  userUuid: string
  showOrganization?: boolean
  showResponsibleUser?: boolean
}

export type TResponsiblePopover = TContractCategoriesList & {
  categoriesList?: boolean
  portfolio?: string
}
export type TResponsiblePopoverContent = {
  led_by: TLedByCC[]
  name: string
  categoriesList?: boolean
}

export type TContractsCategoriesReassignResponsibleData = {
  sourcing_owner: string | null
  sourcing_team: string[]
}

export enum ContractCategoryStatus {
  CONTRACTING = 'contracting',
  CREATED = 'created',
  RFP = 'rfp',
  LOADING = 'loading',
  EXPIRED = 'expired',
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}
